import React from 'react';

import {useTranslation} from 'react-i18next';

import {Spinner} from 'components/ui-kit/Spinner';
import {ProductFormatted} from 'types/products-detail';

import {
    Column,
    ColumnElement,
    ColumnsWrapper,
    HeaderTypography,
    SpinnerContainer,
    Title,
    Typography,
} from './styled';

interface Props {
    data: ProductFormatted;
    isLoading: boolean;
}

export const CommonInfo = ({data, isLoading}: Props) => {
    const {t} = useTranslation();
    return isLoading ? (
        <SpinnerContainer>
            <Spinner />
        </SpinnerContainer>
    ) : (
        <ColumnsWrapper>
            <Column>
                <ColumnElement>
                    <Title>{t('pages.products.detail.common.markingCode')}</Title>
                </ColumnElement>
                <ColumnElement>
                    <HeaderTypography>
                        {t('pages.products.detail.common.generated')}:
                    </HeaderTypography>
                    <Typography highlighted>{data.generatedTime}</Typography>
                </ColumnElement>
                <ColumnElement>
                    <HeaderTypography>{t('pages.products.detail.common.issued')}:</HeaderTypography>
                    <Typography highlighted>{data.issuedTime}</Typography>
                </ColumnElement>
                <ColumnElement>
                    <HeaderTypography>
                        {t('pages.products.detail.common.applied')}:
                    </HeaderTypography>
                    <Typography highlighted>{data.appliedTime}</Typography>
                </ColumnElement>
                <ColumnElement>
                    <HeaderTypography>
                        {t('pages.products.detail.common.aggregated')}:
                    </HeaderTypography>
                    <Typography highlighted>{data.aggregationInfo}</Typography>
                </ColumnElement>
                <ColumnElement>
                    <HeaderTypography>
                        {t('pages.products.detail.common.enteredCirculation')}:
                    </HeaderTypography>
                    <Typography highlighted>{data.enteredCirculationTime}</Typography>
                </ColumnElement>
                <ColumnElement>
                    <HeaderTypography>
                        {t('pages.products.detail.common.leftCirculation')}:
                    </HeaderTypography>
                    <Typography highlighted>{data.leftCirculationTime}</Typography>
                </ColumnElement>
            </Column>
            {data.isAggregate && (
                <Column>
                    <ColumnElement>
                        <Title>{t('pages.products.detail.common.package')}</Title>
                    </ColumnElement>
                    <ColumnElement>
                        <HeaderTypography>
                            {t('pages.products.detail.common.packagingLevel')}:
                        </HeaderTypography>
                        <Typography highlighted>{data.packagingLevel}</Typography>
                    </ColumnElement>
                </Column>
            )}
            <Column>
                <ColumnElement>
                    <Title>{t('pages.products.detail.common.product')}</Title>
                </ColumnElement>
                <ColumnElement>
                    <HeaderTypography>{t('pages.products.detail.common.brand')}:</HeaderTypography>
                    <Typography highlighted>{data.brand}</Typography>
                </ColumnElement>
                <ColumnElement>
                    <HeaderTypography>{t('pages.products.detail.common.name')}:</HeaderTypography>
                    <Typography highlighted>{data.name}</Typography>
                </ColumnElement>
                <ColumnElement>
                    <HeaderTypography>{t('pages.products.detail.common.gtin')}:</HeaderTypography>
                    <Typography highlighted>{data.gtin}</Typography>
                </ColumnElement>
            </Column>
            {data.storageLocation && (
                <Column>
                    <ColumnElement>
                        <Title>{t('pages.products.detail.common.storageLocation.location')}</Title>
                    </ColumnElement>
                    <ColumnElement>
                        <HeaderTypography>
                            {t('pages.products.detail.common.storageLocation.address')}:
                        </HeaderTypography>
                        <Typography highlighted>{data.storageLocation}</Typography>
                    </ColumnElement>
                    <ColumnElement>
                        <HeaderTypography>
                            {t('pages.products.detail.common.storageLocation.name')}:
                        </HeaderTypography>
                        <Typography highlighted>{data.storageName}</Typography>
                    </ColumnElement>
                </Column>
            )}
            <Column>
                <ColumnElement>
                    <Title>{t('pages.products.detail.common.authenticity')}</Title>
                </ColumnElement>
                <ColumnElement>
                    <HeaderTypography>{t('pages.products.detail.common.status')}:</HeaderTypography>
                    {data.authentic.status}
                </ColumnElement>
                <ColumnElement>
                    <HeaderTypography>
                        {t('pages.products.detail.common.statusDate')}:
                    </HeaderTypography>
                    <Typography highlighted>{data.authentic.date}</Typography>
                </ColumnElement>
                <ColumnElement>
                    <HeaderTypography>
                        {t('pages.products.detail.common.eventType')}:
                    </HeaderTypography>
                    <Typography highlighted>{data.authentic.type}</Typography>
                </ColumnElement>
                <ColumnElement>
                    <HeaderTypography>
                        {t('pages.products.detail.common.documentLink')}:
                    </HeaderTypography>
                    <Typography highlighted>{data.authentic.link}</Typography>
                </ColumnElement>
            </Column>
        </ColumnsWrapper>
    );
};
